import { mediaQueryParserNoop } from './parser';
import { Devices } from './types';

export const devices: Devices = {
  ios: mediaQueryParserNoop,
  android: mediaQueryParserNoop,
  iPad: mediaQueryParserNoop,
  iPhoneX: mediaQueryParserNoop,
};
